import { render, staticRenderFns } from "./AlarmExhibitionColumn.vue?vue&type=template&id=1a4e4f60&scoped=true&"
import script from "./AlarmExhibitionColumn.vue?vue&type=script&lang=js&"
export * from "./AlarmExhibitionColumn.vue?vue&type=script&lang=js&"
import style0 from "./AlarmExhibitionColumn.vue?vue&type=style&index=0&id=1a4e4f60&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4e4f60",
  null
  
)

export default component.exports